module.exports = __webpack_public_path__ + "static/media/logo-sofradom.7529933b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/logo-sofradom.png
// module id = 27
// module chunks = 0